import { Spin } from 'antd';
import React from 'react';

import { useFetchAccountOptions } from '../api/actions/useFetchAccountOptions';
// layout needs to be imported as first component
// otherwise css order breaks
// https://github.com/gatsbyjs/gatsby/issues/9733#issuecomment-490132623
import { useFetchInboxDictionary } from '../api/actions/useFetchInboxDictionary';
import { MassOfferingsLayout } from '../components/Layout';
import MassOfferingsContent from '../components/MassOfferingsContent';
import { QUERY_PARAM_KEYS } from '../constants/massOfferings/queryParamKeys';
import { useSearchParams } from '../hooks/useSearchParams';

const MassOfferings = () => {
  const isFetchingAccountOptions = useFetchAccountOptions();
  const { payload: inboxDictionary, loading: isFetchingInboxDictionary } =
    useFetchInboxDictionary();

  const urlSearchParams = useSearchParams();

  const preselectedDate = urlSearchParams.get(QUERY_PARAM_KEYS.selectedDate);

  return (
    <MassOfferingsLayout preselectedDate={preselectedDate}>
      {isFetchingAccountOptions || isFetchingInboxDictionary ? (
        <Spin />
      ) : (
        <MassOfferingsContent inboxDictionary={inboxDictionary} />
      )}
    </MassOfferingsLayout>
  );
};

export default MassOfferings;
